export default {
  default: () => import("/working_dir/layouts/default.vue").then(m => m.default || m),
  "no-footer-layout": () => import("/working_dir/layouts/no-footer-layout.vue").then(m => m.default || m),
  "only-messangers": () => import("/working_dir/layouts/only-messangers.vue").then(m => m.default || m)
}